import Navbar from "./Navbar";
import Footer from "./Footer";
import CookieBanner from "./CookieBanner";

// Wraps every public page in the Webflow theme's `page-wrapper` + `position-relative` structure
// so the theme's CSS (colors, fonts, background) applies. Admin pages skip this and use Tailwind.
// The NOVA chat widget is auto-injected on every public page via /site/js/nova-chat.js — no
// React wrapper needed.
export default function SiteLayout({ children }) {
  return (
    <div className="page-wrapper">
      <div className="position-relative">
        <div className="z-index-1">
          <Navbar />
          <main>{children}</main>
          <Footer />
        </div>
      </div>
      <CookieBanner />
    </div>
  );
}
